import React, { useState } from 'react';
import { HiLogout, HiMenu, HiX } from 'react-icons/hi';
import { useAuth } from 'context/AuthContext';
import logoPremio from 'assets/img/2026/logo_premio.png';
import { isBancaUser } from 'utils/auth';
import './style.scss';

interface HeaderProps {
  currentPage?: 'inicio' | 'iniciativas' | 'minha-jornada' | 'meus-votos';
}

export function Header({ currentPage = 'inicio' }: HeaderProps) {
  const { user, signOut } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const logoutPath = isBancaUser(user) ? '/login-banca' : '/login';

  // Não renderizar até que o usuário esteja carregado
  if (!user) return null;
  
  const getUserName = () => {
    return user.name || 'Usuário';
  };

  const getFirstLetter = () => {
    const name = user.name || 'U';
    return name.charAt(0).toUpperCase();
  };

  const getUserPhoto = () => {
    return user.image?.small?.url;
  };

  return (
    <header className="home-header">
      <div className="home-header__yellow-detail"></div>
      <div className="home-header__content">
        <div className="home-header__brand">
          <button 
            className="home-header__menu-btn" 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Menu"
          >
            {isMenuOpen ? <HiX size={24} color="white" /> : <HiMenu size={24} color="white" />}
          </button>
          <img src={logoPremio} alt="Prêmio BB" className="home-header__logo" />
          <span className="home-header__brand-text">Prêmio BB</span>
        </div>
        <div className="home-header__divider"></div>
        <nav className="home-header__nav">
          <a 
            href="/home-public" 
            className={`home-header__link ${currentPage === 'inicio' ? 'home-header__link--active' : ''}`}
          >
            Início
          </a>
          <a 
            href="/iniciativas" 
            className={`home-header__link ${currentPage === 'iniciativas' ? 'home-header__link--active' : ''}`}
          >
            Iniciativas
          </a>
          <a 
            href="/minha-jornada" 
            className={`home-header__link ${currentPage === 'minha-jornada' ? 'home-header__link--active' : ''}`}
          >
            Minha Jornada
          </a>
        </nav>
        <div className="home-header__user">
          <span className="home-header__username">{getUserName().toUpperCase()}</span>
          <div className="home-header__avatar">
            {getUserPhoto() ? (
              <img src={getUserPhoto()} alt={getUserName()} />
            ) : (
              <span className="home-header__avatar-letter">{getFirstLetter()}</span>
            )}
          </div>
          <button
            className="home-header__logout-btn"
            aria-label="Sair"
            onClick={() => signOut(logoutPath)}
          >
            <HiLogout size={24} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`home-header__mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <nav className="home-header__mobile-nav-links">
          <a 
            href="/home-public" 
            className={`home-header__mobile-link ${currentPage === 'inicio' ? 'active' : ''}`}
          >
            Início
          </a>
          <a 
            href="/iniciativas" 
            className={`home-header__mobile-link ${currentPage === 'iniciativas' ? 'active' : ''}`}
          >
            Iniciativas
          </a>
          <a 
            href="/minha-jornada" 
            className={`home-header__mobile-link ${currentPage === 'minha-jornada' ? 'active' : ''}`}
          >
            Minha Jornada
          </a>
        </nav>
      </div>
    </header>
  );
}
